// Lib
import { colors } from '@/lib/analytics/colors';
import { KPI_VALUE_PERCENT } from '@/hooks/format/useFormatKpiValue';
import { SIZE_50 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';

// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const mediaViewerEngagementRateConfig: KpiType<typeof MediaViewerKpiLoader> = {
    name: 'kpi.pinterest.engagement_rate',
    id: 'engagement_rate',
    icon: {
        name: 'engagement-on',
        style: colors.green
    },
    data_format: KPI_VALUE_PERCENT,
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    loader: MediaViewerKpiLoader
};
